

// import axios from 'axios'
import wx from 'weixin-js-sdk'
import $ from 'jquery';

export function isWeixin() {
  if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 || typeof navigator.wxuserAgent !== 'undefined') {
    return true;
  }
  return false;
}

export function getSignature(obj, cb) {
  console.log('weixin:' + isWeixin())
  if (isWeixin()) {
    const url = location['href'];
    $.ajax({
      type: 'POST',
      // url: location.origin+'/getSignature',
      url: 'https://caiyunapp.com/getSignature',
      data: 'url=' + encodeURIComponent(location.href),
      timeout: 5000,
      success:(data) => {
        var splitData = data.split('__');
        var signatureString = splitData[0];
        var timestampString = Number(splitData[1]);

        wx.config({
          debug: false,
          appId: 'wx9b768083e39b41f5',
          timestamp: timestampString,
          nonceStr: 'caiyunapp',
          signature: signatureString,
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'showMenuItems', 'showAllNonBaseMenuItem'],
        })

        let weixinUrl = location['origin'] + location['pathname']
        let weixinImageUrl = 'https://www.caiyunapp.com/imgs/xiaoyilogo.png'
        let shareTitle = '安利一个免费的文档翻译神器！'
        let shareDesc = '彩云小译，你值得拥有'
        wx.ready(() => {
          if (obj) {
            console.log(obj)
            shareTitle = obj['title'] ? obj['title'] : shareTitle;
            shareDesc = obj['des'] ? obj['des'] : shareDesc;
            weixinImageUrl = obj['img'] ? obj['img'] : weixinImageUrl;
            weixinUrl = obj['url'] ? obj['url'] : weixinUrl
          }
          wx.onMenuShareTimeline({
            title: shareTitle, // 分享标题
            desc: shareTitle, // 分享描述
            link: weixinUrl, // 分享链接
            imgUrl: weixinImageUrl, // 分享图标
            success: () => {
              if (cb) {
                cb()
              }
            },
            cancel: () => {
              if (cb) {
                cb()
              }
            },
          })
          wx.onMenuShareAppMessage({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: weixinUrl, // 分享链接
            imgUrl: weixinImageUrl, // 分享图标
            type: 'link', // 分享类型,music、video或link，不填默认为link
            dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
            success: () => {
              if (cb) {
                cb()
              }
            },
            cancel: () => {
              if (cb) {
                cb()
              }
            },
          })
          wx.onMenuShareQQ({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: weixinUrl, // 分享链接
            imgUrl: weixinImageUrl, // 分享图标
            success: () => {
              if (cb) {
                cb()
              }
            },
            cancel: () => {
              if (cb) {
                cb()
              }
            },
          })
          wx.onMenuShareWeibo({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: weixinUrl, // 分享链接
            imgUrl: weixinImageUrl, // 分享图标
            success: () => {
              if (cb) {
                cb()
              }
            },
            cancel: () => {
              if (cb) {
                cb()
              }
            },
          })
          wx.onMenuShareQZone({
            title: shareTitle, // 分享标题
            desc: shareDesc, // 分享描述
            link: weixinUrl, // 分享链接
            imgUrl: weixinImageUrl, // 分享图标
            success: () => {
              if (cb) {
                cb()
              }
            },
            cancel: () => {
              if (cb) {
                cb()
              }
            },
          })
          wx.showMenuItems({
            menuList: ['menuItem:addContact', 'menuItem:profile'], // 要显示的菜单项，所有menu项见附录3
          })
          wx.showAllNonBaseMenuItem()
        })
        wx.error( res => {
          console.log('err:', res)
        })

      },
      error:(err) => {

      },
    });
    // axios.post('https://caiyunapp.com/getSignature', { 'url': url}).then((res) => {

    //   // wx.error( res => { console.error('wx validate error', res) })
    // }).catch((error) => {
    //   console.log(error)
    // })
  }
}



// WEBPACK FOOTER //
// ./src/api/weixin.js